export const teachers = [
               {
                              id: 1,
                              Image: 'https://labartisan.net/demo/kidsacademy/images/teachers/teacher_12.jpg',
                              name: 'Alex Kshe',
                              subject: 'Math'
               },
               {
                              id: 2,
                              Image: 'https://labartisan.net/demo/kidsacademy/images/teachers/teacher_14.jpg',
                              name: 'Alex Ude',
                              subject: 'English'
               },
               {
                              id: 3,
                              Image: 'https://labartisan.net/demo/kidsacademy/images/teachers/teacher_13.jpg',
                              name: 'Healex Jhonson',
                              subject: 'Art'
               },
               {
                              id: 2,
                              Image: 'https://labartisan.net/demo/kidsacademy/images/teachers/teacher_10.jpg',
                              name: 'Gray Jhonson',
                              subject: 'CCA'
               },
]